import React from 'react';
import { motion } from 'framer-motion';
interface RippleGridProps {
  className?: string;
  /** Grid rows */
  rows?: number;
  /** Grid cols */
  cols?: number;
}
/**
 * Tile grid that emits a ripple from the center outward continuously.
 * Each tile pulses based on its distance from the origin. Great for
 * "scanning" or "validation in progress" moments.
 */
export function RippleGrid({
  className = '',
  rows = 10,
  cols = 18
}: RippleGridProps) {
  const cells = [];
  const cx = (cols - 1) / 2;
  const cy = (rows - 1) / 2;
  const maxDist = Math.sqrt(cx * cx + cy * cy);
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const dx = c - cx;
      const dy = r - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);
      const normalized = dist / maxDist;
      // Each cell waits its turn based on distance from center
      const delay = normalized * 2.5;
      cells.push({
        r,
        c,
        delay,
        normalized
      });
    }
  }
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-240">
      <div className="absolute inset-0 grid" style={{
      gridTemplateColumns: `repeat(${cols}, 1fr)`,
      gridTemplateRows: `repeat(${rows}, 1fr)`,
      gap: '2px'
    }} data-id="element-241">
        {cells.map(cell => <motion.div key={`${cell.r}-${cell.c}`} className="rounded-sm bg-[#1a8fd4]" animate={{
        opacity: [0, 0.4, 0],
        scale: [0.8, 1, 0.8]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        delay: cell.delay,
        ease: 'easeInOut'
      }} style={{
        boxShadow: '0 0 8px rgba(26,143,212,0.6)'
      }} data-id="element-242" />)}
      </div>
    </div>;
}